import React from 'react';

const ArrowLeft: React.FC<React.PropsWithChildren> = () => (
  <path d="M14.8908 0.819519L17.7698 3.69845L5.9771 15.4911L17.7698 27.2838L14.8908 30.1627L0.219229 15.4911L14.8908 0.819519Z" />
);

export default ArrowLeft;
